import ButtonBase from '@material-ui/core/ButtonBase';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Icon from '../Icon';

const ActionableIcon = ({
    onHover, handleClick, label, text, component, disabled,
    className, iconProps, width,
}) => {
    const StyledIconWrapper = styled(ButtonBase)`
        &.stolo-icon-label {
            display: flex;
            flex-direction: column;
            width: ${width};
            min-width: 72px; /* TouchTarget */
            display: flex;
            align-items: center;
            position: relative;
            padding-right: ${props => props.theme.space[5]};
            
            > svg {
                  &:hover {
                    fill: ${onHover || 'inherit'};
                  }
            }
        }
    `;

    const Label = styled.span`
        color: ${props => (
        props.iconProps || {}
    ).iconColor ?
        props.iconProps.iconColor.split('.')
            .reduce((o, i) => o[i], props.theme.palette) :
        props.theme.palette.common.lightBlack};
        display: block;
        padding: 0px;
        margin: 0px;
        text-transform: none;
        font-weight: 100;
        opacity: 1;
        transition: font-size 0.2s, opacity 0.2s;
        transition-delay: 0.1s;
    `;

    const IconLabel = <Label>{label}</Label>;

    return (
        <StyledIconWrapper
            className={className} component={component || 'button'}
            onClick={handleClick} disabled={disabled}
            classes={{ root: 'stolo-icon-label' }}
        >
            <Icon {...iconProps} />
            {IconLabel}
            {text}
        </StyledIconWrapper>
    );
};

ActionableIcon.defaultProps =
    (
{
    onHover: '#CC0066',
    label: null,
    text: null,
    disabled: false,
    component: null,
    className: null,
    iconProps: {},
    width: '6em',
}
    );

ActionableIcon.propTypes = {
    onHover: PropTypes.string,
    handleClick: PropTypes.func.isRequired,
    label: PropTypes.string,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    component: PropTypes.string,
    className: PropTypes.string,
    iconProps: PropTypes.shape({
        name: PropTypes.string.isRequired,
        width: PropTypes.string,
        height: PropTypes.string,
        iconColor: PropTypes.string,
        className: PropTypes.string,
        onHover: PropTypes.string,
        icons: PropTypes.objectOf(PropTypes.any),
    }),
    width: PropTypes.string,
};

export default ActionableIcon;



// WEBPACK FOOTER //
// ./src/components/buttons/ActionableIcon.js